import React from 'react';
import { Keyboard } from 'lucide-react';
import { FormModal } from '@/common/forms/FormModal';

interface ShortcutItem {
    keys: string[];
    description: string;
}

interface ShortcutsHelpModalProps {
    isOpen: boolean;
    onClose: () => void;
    shortcuts: ShortcutItem[];
}

export const ShortcutsHelpModal: React.FC<ShortcutsHelpModalProps> = ({ isOpen, onClose, shortcuts }) => {
    return (
        <FormModal
            isOpen={isOpen}
            onClose={onClose}
            title="System Shortcuts"
            subtitle="Operational Velocity Optimization"
            maxWidth="max-w-4xl"
        >
            <FormModal.Content className="space-y-10 py-8">
                <div className="bg-gray-50/50 rounded-[2.5rem] p-8 border border-gray-100 flex items-center gap-6">
                    <div className="w-16 h-16 bg-white rounded-3xl shadow-sm flex items-center justify-center text-primaryGreen flex-shrink-0">
                        <Keyboard className="w-8 h-8" />
                    </div>
                    <div className="space-y-1">
                        <p className="text-sm font-black text-darkGreen font-outfit uppercase tracking-tighter italic">Macro Efficiency Protocol</p>
                        <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest leading-relaxed">
                            Boost your productivity with these global keyboard sequences integrated into KMStack Core.
                        </p>
                    </div>
                </div>

                <div className="grid gap-4">
                    {shortcuts.map((shortcut, index) => (
                        <div key={index} className="flex items-center justify-between p-5 bg-white border border-gray-100 rounded-2xl hover:border-primaryGreen/20 hover:bg-gray-50/30 transition-all group">
                            <span className="text-[11px] font-black text-darkGreen uppercase tracking-widest opacity-60 group-hover:opacity-100 transition-opacity">
                                {shortcut.description}
                            </span>
                            <div className="flex gap-1.5 Items-center">
                                {shortcut.keys.map((key, kIndex) => (
                                    <React.Fragment key={kIndex}>
                                        <kbd className="min-w-[28px] h-7 px-2 flex items-center justify-center rounded-lg border-2 border-gray-200 bg-white font-mono text-[10px] font-black text-darkGreen shadow-sm">
                                            {key}
                                        </kbd>
                                        {kIndex < shortcut.keys.length - 1 && (
                                            <span className="text-gray-300 font-black text-xs">+</span>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </FormModal.Content>

            <FormModal.Footer
                onCancel={onClose}
                onSubmit={onClose}
                submitLabel="Dismiss Intelligence"
                isLastStep={true}
                hideCancel={true}
            />
        </FormModal>
    );
};
